"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFromMexicanPeso = exports.parseToMexicanPeso = void 0;
function parseToMexicanPeso(value) {
    return value.toLocaleString("es-MX", { style: "currency", currency: "MXN" });
}
exports.parseToMexicanPeso = parseToMexicanPeso;
function parseFromMexicanPeso(value) {
    const cleanedValue = value.replace(/[^0-9.]/g, "");
    const parsedNumber = parseFloat(cleanedValue);
    return isNaN(parsedNumber) ? 0 : parsedNumber;
}
exports.parseFromMexicanPeso = parseFromMexicanPeso;
